import { render, staticRenderFns } from "./LlStepperStep.vue?vue&type=template&id=80b54ac2&scoped=true"
import script from "./LlStepperStep.vue?vue&type=script&lang=js"
export * from "./LlStepperStep.vue?vue&type=script&lang=js"
import style0 from "./LlStepperStep.vue?vue&type=style&index=0&id=80b54ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b54ac2",
  null
  
)

export default component.exports